import React from "react";
import { LegalLayout, H2, P, UL, LI } from "@/components/LegalLayout";

export default function Disclaimer() {
  return (
    <LegalLayout
      title="Disclaimer & Safety"
      updated="June 1, 2026"
      intro="Please read this carefully. Next Time is a self-improvement practice tool, and there are important limits to what it can do."
    >
      <div className="rounded-2xl bg-clay-light border border-clay/30 p-6 mb-8">
        <p className="font-serif text-xl text-clay">If you are in crisis, get help now</p>
        <p className="mt-2 text-ink leading-relaxed">
          Next Time cannot help in an emergency. If you or someone else may be in danger, contact your local emergency services immediately. In the U.S., call or text <strong>988</strong> for the Suicide &amp; Crisis Lifeline. You deserve support from a trained person.
        </p>
      </div>

      <H2>1. Not medical or professional advice</H2>
      <P>Next Time does not provide medical, psychological, psychiatric, therapeutic, legal, or financial advice. It is not a healthcare provider and does not diagnose, treat, or cure any condition. It is not a substitute for professional care. Always seek the advice of a qualified professional for questions about your health or wellbeing.</P>

      <H2>2. Not a crisis or emergency service</H2>
      <P>The Software is not designed for use in emergencies and does not monitor for or respond to crises. Do not rely on it if you are experiencing thoughts of self-harm, harm to others, abuse, or any urgent situation. Use the resources above instead.</P>

      <H2>3. AI-generated content may be wrong</H2>
      <P>Scenarios, role-play responses, analysis, feedback, and scores are generated by artificial intelligence and may be inaccurate, incomplete, biased, or inappropriate for your specific situation. Treat all output as suggestions for reflection and practice, not as facts or professional guidance. Use your own judgment.</P>

      <H2>4. You are responsible for your decisions</H2>
      <P>Any actions you take in real conversations or relationships are your own responsibility. Next Time is a rehearsal space; outcomes in the real world depend on many factors outside our control. We are not responsible for the results of decisions you make based on the Software.</P>

      <H2>5. Practice, not a promise</H2>
      <P>Practicing a conversation can help you feel more prepared, but it does not guarantee any particular outcome. People and situations are unpredictable.</P>

      <H2>6. Safety features are limited</H2>
      <P>The Software includes basic safety prompts that may surface crisis resources when certain topics are detected. These checks are limited, may miss things, and are not a monitoring or intervention service. Never depend on them for your safety.</P>

      <H2>7. Individual results vary</H2>
      <P>Any examples, testimonials, or progress indicators are illustrative and do not guarantee similar results for you.</P>

      <H2>8. Questions</H2>
      <P>If anything here is unclear, email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a>. This notice works together with our <a href="/terms" className="underline hover:text-ink">Terms of Service</a> and <a href="/privacy" className="underline hover:text-ink">Privacy Policy</a>.</P>
    </LegalLayout>
  );
}
